import { useState } from 'react';
import PriorityItem, { PriorityItemComponentProps } from './PriorityItem.component';

type PrioritiesComponentType = Omit<
  PriorityItemComponentProps,
  'checked' | 'onChangePriorityStatus'
>;

type PriorityItemContainerProps = PrioritiesComponentType & {
  id: string;
  isPriorityFinished: boolean;
  handleUpdatePriorityStatus?: (answerId: string, isPriorityFinished: boolean) => void;
};

const PriorityItemContainer = function ({
  id,
  hideCopyButton,
  disablePriority,
  isPriorityFinished,
  description,
  onCopyPriorityHandler,
  handleUpdatePriorityStatus,
}: PriorityItemContainerProps): JSX.Element {
  const [checked, setChecked] = useState(isPriorityFinished);

  const onChangePriorityStatus = (): void => {
    if (disablePriority) {
      return;
    }
    setChecked(!checked);
    if (handleUpdatePriorityStatus) {
      handleUpdatePriorityStatus(id, !checked);
    }
  };

  return (
    <PriorityItem
      disablePriority={disablePriority}
      hideCopyButton={hideCopyButton}
      checked={checked}
      description={description}
      onCopyPriorityHandler={onCopyPriorityHandler}
      onChangePriorityStatus={onChangePriorityStatus}
    />
  );
};

export default PriorityItemContainer;
